{
    "Ticket": "Ticket",
    "Tickets": "Tickets",
    "Ticket wählen": "Ticket wählen",
    "Tickets auswählen": "Tickets auswählen",
    "Tickets ausgewählt": "ausgewählt",
    "Alle Arten": "Alle Arten",
    "Ticketarten": "Ticket types",
    "Ja": "Ja",
    "Nein": "Nein",
    "für": "für",
    "Checkout": "Kasse",
    "Nicht mehr verfügbar": "Nicht mehr verfügbar",
    "Noch nicht verfügbar": "Noch nicht verfügbar",
    "Required": "Benötigt",
    "Empfänger bestimmen": "Empfänger bestimmen",
    "Zusammenfassung": "Zusammenfassung",
    "Persönliche Daten": "Persönliche Daten",
    "Zahlungsart auswählen": "Zahlungsart auswählen",
    "Die Zahlungsarten erscheinen, sobald ein Land ausgewählt ist.": "Die Zahlungsarten erscheinen, sobald ein Land ausgewählt ist.",
    "Für das gewählte Land ist keine Zahlungsart verfügbar.": "Für das gewählte Land ist keine Zahlungsart verfügbar.",
    "Weiter": "Weiter",
    "Zurück": "Zurück",
    "Vorkasse": "Vorkasse",
    "Vorname": "Vorname",
    "Nachname": "Nachname",
    "Straße und Hausnummer": "Straße und Hausnummer",
    "Firma": "Firma",
    "USt-Id": "USt-Id",
    "Email": "E-Mail",
    "E-Mail": "E-Mail",
    "PLZ": "PLZ",
    "Ort": "Ort",
    "Land": "Land",
    "Empfänger": "Empfänger",
    "Anzahl": "Anzahl",
    "Art": "Art",
    "Enthaltene MwSt.": "Enthaltene MwSt.",
    "Preis": "Preis",
    "Zahlungsweise": "Zahlungsweise",
    "Gesamt": "Gesamt",
    "Total": "Gesamt",
    "Jetzt kaufen": "Jetzt kostenpflichtig kaufen",
    "Jetzt kostenlos bestellen": "Jetzt kostenlos bestellen",
    "Einkaufsliste": "Einkaufsliste",
    "Dies ist keine E-Mail-Adresse!": "Dies ist keine E-Mail-Adresse!",
    "Nichts gefunden": "Nichts gefunden",
    "Personalisieren": "Personalisieren",
    "Personalisierung": "Personalisierung",
    "Personalisiere die Tickets": "Personalisiere die Tickets",
    "Ich habe die": "Ich habe die",
    "AGB": "AGB",
    "gelesen und akzeptiert.": "gelesen und akzeptiert.",
    "Datenschutzerklärung": "Datenschutzerklärung",
    "Vielen Dank für die Bestellung! In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.": "Vielen Dank für die Bestellung! In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.",
    "Entschuldigung, es gab einen Fehler bei der Übermittlung:": "Entschuldigung, es gab einen Fehler bei der Übermittlung:",
    "Entschuldigung, der Server meldet einen Fehler. Bitte versuche es später noch einmal.": "Entschuldigung, der Server meldet einen Fehler. Bitte versuche es später noch einmal.",
    "Bitte versuche es später noch einmal.": "Bitte versuche es später noch einmal.",
    "Teilnehmerdaten": "Teilnehmerdaten",
    "Entschuldigung. Die Anzahl der gewünschten Tickets ist derzeit nicht verfügbar.": "Entschuldigung. Die Anzahl der gewünschten Tickets ist derzeit nicht verfügbar.",
    "Beim Abschluss der Bestellung ist ein Fehler aufgetreten:": "Beim Abschluss der Bestellung ist ein Fehler aufgetreten:",
    "Bitte überprüfe die AGBs": "Bitte überprüfe die AGBs und Datenschutzerklärung",
    "Geimpft/Genesen": "Geimpft/Genesen",
    "Weder Geimpft noch Genesen": "Weder Geimpft noch Genesen",
    "Keine Angabe": "Keine Angabe",
    "Ticket entfernen": "Ticket entfernen",
    "Ticket entfernen?": "Soll das Ticket wirklich entfernt werden?",
    "Es wurden bereits Eingaben gespeichert. Sollen diese verwendet werden?": "Es wurden bereits Eingaben gespeichert. Sollen diese verwendet werden?",
    "Keine gültige E-Mail-Adresse": "Keine gültige E-Mail-Adresse",
    "Tage": "Tage",
    "Mi": "Mi",
    "Do": "Do",
    "Fr": "Fr",
    "Sa": "Sa",
    "So": "So",
    "Mo": "Mo",
    "Karteninhaber": "Karteninhaber",
    "Kreditkartennummer": "Kreditkartennummer",
    "Verfallsdatum": "Verfallsdatum",
    "Bezahlen": "Bezahlen",
    "Zahlung gesichert und bereitgestellt von": "Zahlung gesichert und bereitgestellt von",
    "OpenPaymentBeforeUnload" : "Sicher, dass das Fenster geschlossen werden soll? Die Bestellung wird unwiderruflich abgebrochen.",
    "Der eingegebene Gutschein-Code ist nicht gültig." : "Der eingegebene Gutschein-Code ist nicht gültig.",
    "Ich habe einen Gutschein-Code" : "Ich habe einen Gutschein-Code",
    "Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert." : "Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert!",
    "Gutschein-Code" : "Gutschein / Code",
    "Die Prüfung des Gutscheins erfolgt im nächsten Schritt" : "Die Prüfung des Gutscheins erfolgt im nächsten Schritt",
    "Coupon-Code nicht gefunden oder nicht mehr gültig." : "Gutschein / Code nicht gefunden oder nicht mehr gültig.",
    "Ich möchte einen Betrag spenden" : "Ich möchte einen Betrag spenden",
    "Welcher Betrag soll gespendet werden?" : "Welcher Betrag soll gespendet werden?",
    "Wir freuen uns über eine freiwillige Spende." : "Wir freuen uns über eine freiwillige Spende.",
    "Anderer Betrag" : "Anderer Betrag",
    "Andere" : "Andere",
    "Spende" : "Spende",
    "Gutschein" : "Gutschein",
    "Gutschein gilt nur für bestimmte Produkte": "Gutschein gilt nur für bestimmte Produkte",
    "Einen Coupon / Code hier eingeben": "Einen Gutschein / Code hier eingeben",
    "Oh nein! Ein Fehler trat auf" : "Da ist etwas schiefgelaufen.",
    "Dieser Shop wurde nicht gefunden." : "Dieser Shop wurde nicht gefunden.",
    "Dieser Shop ist zurzeit nicht aktiv." : "Dieser Shop ist zurzeit nicht aktiv.",
    "Fehler" : "Fehler",
    "Aktuell gibt es keine Produkte in diesem Shop." : "Aktuell gibt es keine Produkte in diesem Shop.",
    "Bestellung bezahlt" : "Bestellung bezahlt",
    "Bestellung nicht gefunden" : "Bestellstatus",
    "Leider konnte die Bestellung nicht gefunden werden." : "Leider konnte die Bestellung nicht gefunden werden. Aktuell kann aus technischen Gründen kein Status zu dieser Bestellung ermittelt werden. In Kürze sollte eine E-Mail mit allen Infos eingehen.",
    "Bestellung eingegangen" : "Bestellung eingegangen",
    "Die Bestellung ist bei uns eingegangen. In Kürze sollte eine E-Mail mit Zahlungsinformationen eingehen." : "Die Bestellung ist bei uns eingegangen. In Kürze sollte eine E-Mail mit Zahlungsinformationen eingehen.",
    "Die Bezahlung war erfolgreich. Vielen Dank! Wir melden uns schnellstmöglich bei Dir per E-Mail." : "Die Bezahlung war erfolgreich. Vielen Dank! Wir melden uns schnellstmöglich bei Dir per E-Mail.",
    "Bestellung abgebrochen": "Bestellung abgebrochen",
    "Leider wurde die Bestellung abgebrochen. Bitte gern später nochmal versuchen." : "Leider wurde die Bestellung abgebrochen. Bitte gern später nochmal versuchen.",
    "Status der Bestellung" : "Die Bestellung befindet sich im Status",
    "Direktverkauf" : "Direktverkauf",
    "Vor-Ort Ticketshop" : "Vor-Ort Ticketshop",
    "Eingeloggt als:" : "Eingeloggt als:",
    "Ausloggen" : "Ausloggen",
    "Mehr erfahren" : "Mehr erfahren",
    "Coupon-Tickets": "Coupon-Tickets",
    "Alle Tickets anzeigen": "Alle Tickets anzeigen",
    "Bitte auswählen": "Bitte auswählen",
    "Ticket direkt an Käufer:In schicken": "Ticket direkt an Käufer:In schicken",
    "CheckPopup": "Bitte im Browser aktivieren, dass das Mollie Zahlungsfenster als Popup geöffnet werden darf. Gegebenenfalls Popup-Blocker o.ä. deaktivieren.",
    "Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?": "Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?",
    "Reduzierte Produkte sind hervorgehoben.": "Reduzierte Produkte sind hervorgehoben.",
    "Beinhaltet": "Beinhaltet",
    "Ich möchte auf dem Laufenden bleiben": "Ich möchte auf dem Laufenden bleiben",
    "Vielen Dank für die Bestellung!": "Vielen Dank für die Bestellung!",
    "In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.": "In Kürze sollte eine Bestätigungsmail eingehen. Bitte auch den Spam-Ordner überprüfen.",
    "PDF drucken über": "PDF drucken über",
    "Label drucken über": "Label drucken über",
    "Download (in neuem Tab öffnen)": "Download (in neuem Tab öffnen)",
    "PDF drucken": "PDF drucken",
    "Label drucken": "Label drucken",
    "PDF herunterladen": "PDF herunterladen",
    "Label herunterladen": "Label herunterladen",
    "… wird gedruckt": "… wird gedruckt",
    "✓ gedruckt": "✓ gedruckt",
    "Fehler — bitte erneut versuchen": "Fehler — bitte erneut versuchen",
    "Produkte durchsuchen": "Produkte durchsuchen",
    "Keine Produkte gefunden": "Keine Produkte gefunden",
    "Suche zurücksetzen": "Suche zurücksetzen",
    "Suche schließen": "Suche schließen",
    "Produkt": "Produkt",
    "Produkte": "Produkte"
}
